import styled from "@emotion/styled";
import { Visibility } from "@mui/icons-material";
import { Avatar, IconButton, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "components/UI";
import { IMAGE_URL } from "config";
import i18next from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useCentralStore } from "stores";
import { useDenominationChurches } from "../api";

const DownloadLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 500;
  font-size: 14px;
  padding: 6px 8px;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DenominationChurches = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const setHeaderTitle = useCentralStore(state => state.setHeaderTitle);

  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const churchesQuery = useDenominationChurches({
    denominationId: id,
    page,
    pageSize
  });

  // const { mutate: promoteDenominationChurch, isLoading: isPromoting } =
  //   usePromoteDenominationChurch();

  useEffect(() => {
    setHeaderTitle(t("denominations.churches.title"));

    return () => {
      setHeaderTitle("");
    };
  }, [setHeaderTitle, i18next.language]);

  const columns = [
    {
      field: "image",
      headerName: "",
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: params => (
        <Avatar
          src={`${IMAGE_URL}/${params.row.image_url}`}
          alt={params.row.name}
          sx={{ width: 40, height: 40 }}
        />
      )
    },
    {
      field: "name",
      headerName: t("denominations.churches.churchName"),
      flex: 1,
      minWidth: 600
    },
    { field: "email", headerName: t("denominations.churches.email"), flex: 1 },
    { field: "phone", headerName: t("denominations.churches.phone"), flex: 1 },
    {
      field: "created_at",
      headerName: t("denominations.churches.createdAt"),
      flex: 1,
      valueFormatter: params => moment(params.value).format("DD/MM/YYYY")
    },
    {
      field: "actions",
      headerName: t("denominations.churches.actions"),
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: params => (
        <IconButton
          onClick={() =>
            navigate(`/denomination-dashboard/${id}/churches/${params.row.id}`)
          }
          size="small"
        >
          <Visibility />
        </IconButton>
      )
    }
    // {
    //   field: "promote",
    //   headerName: "Promotion",
    //   flex: 1,
    //   sortable: false,
    //   filterable: false,
    //   renderCell: params => (
    //     <Button
    //       onClick={() =>
    //         promoteDenominationChurch({
    //           denominationId: id,
    //           churchId: params.row.id,
    //           churchData: params.row
    //         })
    //       }
    //       size="small"
    //       disabled={isPromoting}
    //     >
    //       Promote
    //     </Button>
    //   )
    // }
  ];

  return (
    <Stack py={3} spacing={5}>
      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <DownloadLink href="/forms/church-form.pdf" download="Church Form">
          {t("denominations.churches.downloadChurchForm")}
        </DownloadLink>
        <Button
          onClick={() =>
            navigate(`/denomination-dashboard/${id}/churches/create`)
          }
        >
          {t("denominations.churches.createChurch")}
        </Button>
      </Stack>
      <DataGrid
        autoHeight
        rows={churchesQuery?.data?.result || []}
        rowCount={churchesQuery?.data?.result?.total || 0}
        loading={churchesQuery?.isLoading}
        columns={columns}
        rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
        density="comfortable"
        getRowId={row => row.id}
        disableColumnMenu
        disableSelectionOnClick
        pagination
        paginationMode="server"
        page={page - 1}
        pageSize={pageSize}
        onPageChange={newPage => setPage(newPage + 1)}
        onPageSizeChange={newPageSize => setPageSize(newPageSize)}
        localeText={{
          noRowsLabel: t("teams.teamProfile.NoRows"),
          MuiTablePagination: {
            labelRowsPerPage: t("teams.teamProfile.RowsPerPage")
          }
        }}
      />
    </Stack>
  );
};
